import { Image } from "common/types/images";

import { getCdnImageDetails } from "seneca-common/utils/images";

import {
  ConceptContent,
  ConceptContentSource,
  ImageAssetParameters
} from "../types";

export function getModuleAssets(source: ConceptContent): Array<Image> {
  return source.examples.map(example => example.image);
}

export function transformModuleAssets(
  { examples, ...source }: ConceptContentSource,
  assetParams: ImageAssetParameters
): ConceptContent {
  return {
    ...source,
    examples: examples.map(({ url, ...example }) => {
      return {
        ...example,
        image: getCdnImageDetails(url, assetParams.default)
      };
    })
  };
}
